import { createAsyncThunk } from "@reduxjs/toolkit";
import { getNFTDetailsService, getWalletAddressService, markedAsSold } from "../../apiService/nftDetails";

export const getNFTDetails = createAsyncThunk(
  "vyga/getNFTDetails",
  async (nftId: string | undefined, { rejectWithValue }) => {
    try {
      const result = await getNFTDetailsService(nftId);
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getWalletAddress = createAsyncThunk(
  "vyga/getNFTDetails",
  async (_, { rejectWithValue }) => {
    try {
      const result = await getWalletAddressService();
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
interface postData {
  nftId: string;
};

export const soldMarked = createAsyncThunk(
  "vyga/getNFTDetails",
  async (nftId: postData, { rejectWithValue }) => {
    try {
      const result = await markedAsSold(nftId);
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
